
    var riot = require('riot')
    //src: starling/src/tags/modal-search.html
riot.tag2('modal-search',
  '<label class="modal-search_container mrgn-r-4"> <svg class="modal-search_lupe"> <use xlink:href="#search-icon"></use> </svg> <input ref="search" onkeydown="{stopPropagation}" onkeyup="{handleInput}" class="modal-search_input" placeholder="Find in map"> <span if="{getResultTotal()}" class="modal-search_count"> <span if="{getResultNumber() < 0}"> {getResultTotal()} </span> <span if="{getResultNumber() >= 0}"> {getResultNumber() + 1} / {getResultTotal()} </span> </span> </label> <button class="Button Button--Plain Button--Icon" onclick="{gotoPrevResult}" data-tip="{getResultTotal() ? \'Find previous\' : \'\'}" disabled="{!getResultTotal()}"> <svg class="Button__Icon"> <use xlink:href="#chevron-left-icon"></use> </svg> </button> <button class="Button Button--Plain Button--Icon" onclick="{gotoNextResult}" data-tip="{getResultTotal() ? \'Find next\' : \'\'}" disabled="{!getResultTotal()}"> <svg class="Button__Icon"> <use xlink:href="#chevron-right-icon"></use> </svg> </button> <button class="Button Button--Plain Button--Icon mrgn-l-4" onclick="{dismiss}" data-tip="Close"> <svg class="Button__Icon"> <use xlink:href="#close-icon"></use> </svg> </button>',
  '',
  'class="modal-search {!user && \'modal-search--logged-out\'}" style="display: none;"', function(opts) {
'use strict';

var _this = this;

var _constants = require('lib/constants');

var _searchUi = require('lib/search-ui');

var ENTER = _constants.KEY_CODES.ENTER,
    ESCAPE = _constants.KEY_CODES.ESCAPE;
var _opts = opts,
    canvas = _opts.canvas;

canvas.searchModal = this;

this.open = false;

this.shouldOpenSearchModal = function () {
  // Don't open finder if share or image modal is open
  if (canvas.shareModal.isOpen() || canvas.imageModal.isOpen()) {
    return false;
  }

  return true;
};

this.show = function () {
  var search = _this.refs.search;

  if (!_this.shouldOpenSearchModal()) {
    // don't show if help sidebar is open
    return;
  }

  canvas.hidePopups();

  _this.open = true;

  $(_this.root).slideDown('fast');

  search.focus();
  search.select();
};

this.dismiss = function (e) {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }

  _searchUi.searchUI.dismiss();

  _this.open = false;
  _this.update();

  $(_this.root).slideUp('fast');
};

this.handleInput = function (e) {
  var keyCode = e.keyCode;

  e.preventDefault();
  e.stopPropagation();

  _searchUi.searchUI.generateResults();

  if (keyCode === ENTER) {
    _searchUi.searchUI.prepareFirstResult();
    _this.gotoNextResult();
  } else if (keyCode === ESCAPE) {
    _this.dismiss();
  }

  _this.update();
};

this.getResultTotal = function () {
  return _searchUi.searchUI.searchResults.length;
};

this.getCurrentQuery = function () {
  return _searchUi.searchUI.currentQuery;
};

this.getResultNumber = function () {
  return _searchUi.searchUI.resultIndex;
};

this.gotoNextResult = function () {
  _searchUi.searchUI.gotoNextResult();
  _this.update();
};

this.gotoPrevResult = function () {
  _searchUi.searchUI.gotoPrevResult();
  _this.update();
};

this.refreshResults = function () {
  _searchUi.searchUI.refreshResults();
};

this.stopPropagation = function (e) {
  return e.stopPropagation();
};

this.on('mount', function () {
  var search = _this.refs.search;

  _searchUi.searchUI.setSearchModal(_this);
  _searchUi.searchUI.setSearchInputElement(search);
  _searchUi.searchUI.searchKeyOverride(search);
  _searchUi.searchUI.searchKeyIteratorOverride(search);
});
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('modal-search')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/modal-search.html
// module id = 632
// module chunks = 0